export const dateFormat = 'MM/DD/YYYY';
export const minStepsBetweenThumbs = 2;
